// used for page materials, showroom and inner slider block

import Glide from '@glidejs/glide'
import { updateNumbers, updateBar } from './slider-utils'


const initCaseGliders = () => {

    const setupBlock = (block) => {

        let gliderRoot = block.querySelector(".glide");
        if (!gliderRoot) return;

        /* get container padding pixel value for mobile */
        //const rootStyle = getComputedStyle(document.documentElement);
        //const pixelValue = parseInt(rootStyle.getPropertyValue('--cont-px-pixelvalue').trim());

        let options = {
            type: 'carousel',
            perView: 2,
            autoplay: false,
            animationDuration: 800,
            swipeThreshold: 40, //default 80, which is a bit too lazy
            dragThreshold: 60, //default 120, which is a bit too lazy
            touchAngle: 30,
            gap: 32,
            peek: 0,
            breakpoints: {
                1024: {
                    autoplay: false,
                    perView: 1,
                    peek: 0,
                    gap: 8,
                },
                800: {
                    autoplay: false,
                    perView: 1,
                    peek: 0,
                    gap: 8,
                },
                640: {
                    autoplay: false,
                    perView: 1,
                    peek: 20,
                    gap: 10,
                },
                500: {
                    autoplay: false,
                    perView: 1,
                    peek: 20,
                    gap: 10,
                }
            }
        }
        const glide = new Glide(gliderRoot, options);

        // Dependent elements controlled by glider
        //const sliderNumbers = block.querySelectorAll(".js-sliderNumber");
        //const sliderBar = block.querySelector(".js-sliderBar")


        glide.on('mount.after', function () {
            gliderRoot.classList.add('mounted')
        })

        glide.on('run', () => {

            //updateNumbers(sliderNumbers, glide.index);
            //updateBar(sliderBar, sliderNumbers, glide.index);
        })



        glide.mount()
    }

    /* setup the blocks */
    let blocks = document.querySelectorAll(".js-block-cases-slider");

    if (!blocks) return;

    blocks.forEach(block => {
        setupBlock(block);
    });
}

export { initCaseGliders }
